import React from 'react';
import { useSelector } from 'react-redux';
import { removeKebabCase } from 'hpstore-helpers';
import Button from '../../../ui/components/button';
const siteConfigSelector = ({ siteConfig }) => siteConfig && siteConfig.blog && siteConfig.blog.ctaAbtest


// if the blog has any of these tags, don't display the CTA.
const tagsWithoutCTA = {
  "tech-at-work": 1
}

function shouldRenderCTA(tags) {
  if (!tags) return true;

  for (let tag of tags) {
    if (tagsWithoutCTA[tag]) return false;
  }

  return true;
}

const Cta = ({ tags = [], hideCta }) => {
  const ctaAbtest = useSelector(siteConfigSelector) || {}
  const { tags: tagsMap, tagsWithoutCTA } = ctaAbtest || {};

  if (hideCta || !shouldRenderCTA(tags)) return null;

  let ctaLink = siteConfig.blog.ctaAbtest.ctaLink;
  const normalizedTags = tags.map(t => removeKebabCase({ str: t }).replace(/\s+/g, '').toLowerCase()).join('');

  for (let key in tagsMap) {
    if (normalizedTags.indexOf(key) > -1) {
      ctaLink = tagsMap[key]
      break;
    }
  }

  return (
    <div className="hero-banner-cta-container">
      <div className="cta-text">Explore our products</div>
      <div className="cta">
        <a href={ctaLink} target="_blank">
          <Button text="Buy" action="go" />
        </a>
      </div>
    </div>
  )
};

export default React.memo(Cta);